import type { MachineSetupRepository } from '../data/machine-setup-repository';
import type { SaveTypeSettingsRequest } from '../types/machine-setup-types';

export class SaveTypeSettingsUseCase {
  constructor(private readonly repository: MachineSetupRepository) {}

  async execute(key: string, settings: SaveTypeSettingsRequest): Promise<{ isSuccess: boolean; errorMessage?: string }> {
    return this.repository.saveTypeSettings(key, settings);
  }
}
